
export default {
    name: "NavigationCard",
    props: {
        result: {
            type: Object,
            required: true,
            imageSrc: {
                type: String,
                required: true,
            },
            imageAlt: {
                type: String,
                required: true,
            },
            title: {
                type: String,
                required: true,
            },
            url: {
                type: String,
                required: true,
            }
        }
    },
    setup(){
        
        return {
           
        }
    }
}